export default __webpack_public_path__ + "static/media/Gesture_white_Squeeze-15.44c7fb83.svg";